import React, { useEffect, useState } from "react";
import DownloadCountryPoliciesResponses from '../../../services/downloadCountryPoliciesResponsesTable.jsx';
import Button from 'react-bootstrap/Button';
import { exportMultipleChartsToPdf } from '../../../services/exportGraphsToPdf';
import '../../../styles/tableau.css'; 
import { useTranslation } from 'react-i18next';


function DownloadDataGlobal(props) {
const { t } = useTranslation();

  const [dataFromServer, setDataFromServer] = useState("");
  const[jsonLoaded, setLoad] = useState(false);


  useEffect(() => {
   
   
    
  
   
  
    const fetchData = async () => {
      if(jsonLoaded === false) {
            fetch(`${process.env.REACT_APP_BACKEND_API}/submission/report/all/`, {
             method: "GET",
              headers: {
              "accept": "application/json",
                 "Authorization": `Token ${process.env.REACT_APP_BACKEND_TOKEN}`
              },
    })
      .then((response) => response.json())
      .then((data) => {
        setDataFromServer(data);
        // console.log("data from server");
        // console.log(data);
      })
      .catch((error) => console.log(error));
           setLoad(true);
          
      }
    };
  
    fetchData();
  }, [props.lang, jsonLoaded]);

 
    return (

    <React.Fragment>   
       
      <br></br>
      <br></br>
      <div className="App">
    {dataFromServer !== undefined && dataFromServer.length > 0 ?
     <div style={{display: "flex", justifyContent: "flex-end"}}>
     <span> <DownloadCountryPoliciesResponses type={"policies"} page={"allData"} data={dataFromServer}/></span> 
      <span>   <Button  onClick={exportMultipleChartsToPdf} style={{marginLeft: "10px", marginRight:"10px", backgroundColor: "#116AAB",  border:"1px solid #116AAB"}}>{t("download_charts")}</Button></span>
    </div>
     : <div></div>} </div>
  
     

    {/* // <Tableau type={props.type}/> */}
     
    </React.Fragment>




   
  );
}
  export default DownloadDataGlobal;